import Vue from 'vue'
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
// 图片双击方大插件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

Vue.use(Mint);
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    "inline": true,
    "button": true,
    "navbar": true,
    "title": false,
    "toolbar": false,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": false,
    "transition": true,
    "fullscreen": true,
    "keyboard": false,
    "url": "data-source"
  }
});
